import { Chip, XIcon } from '@keplerco/core';
import React from 'react';
import Accordion from '../../../../components/accordion/accordion';
import { EmptyState } from '../../../../components/general/empty-state/empty-state';
import { OptionButton } from '../../../../components/general/option-button/option-button';
import { TertiaryButton } from '../../../../components/general/tertiary-button/tertiary-button';
import { RatingAssessmentAccordionEmptyStateImage } from './rating-assessment-accordion-empty-state.image';
import styles from './rating-assessment-accordion.module.css';
import { PeerAssessmentAssigneeResponse } from '../../../../overmind/actions';
import { AssessmentAssigneeListItemLayout } from '../../../../components/assessment/assessment-entity-list-item.layout';

export function SkillsAccordion({ assignee, onAdd, onRemove }: { assignee: PeerAssessmentAssigneeResponse; onAdd: () => void; onRemove: (slug: string) => void }) {
  function AccordionHeader() {
    return (
      <div className={styles.accordionHeader}>
        <AssessmentAssigneeListItemLayout assignee={assignee}>
          <Chip customTheme={{ backgroundColor: 'white', borderColor: 'baby-blue', color: 'text' }}>
            {assignee.companySkills.length} {assignee.companySkills.length === 1 ? 'skill' : 'skills'}
          </Chip>

          <TertiaryButton
            type="button"
            onClick={e => {
              e.stopPropagation();
              onAdd();
            }}
          >
            Add
          </TertiaryButton>
        </AssessmentAssigneeListItemLayout>
      </div>
    );
  }

  return (
    <Accordion header={<AccordionHeader />}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {!!assignee.companySkills.length ? (
          <>
            <h6>{`These are the skills ${assignee.fullName} will be assessed on:`}</h6>
            {assignee.companySkills.map(companySkill => (
              <OptionButton style={{ width: '100%', display: 'grid', gridTemplateColumns: '1fr 1fr 16px', textAlign: 'start' }} key={companySkill.slug} onClick={() => onRemove(companySkill.slug)}>
                <div>{companySkill.name}</div>
                <div>{companySkill.skillCategories?.map(skillCategory => skillCategory.name).join(', ')}</div>
                <XIcon size={16} />
              </OptionButton>
            ))}
          </>
        ) : (
          <EmptyState title="" subtitle={`The selected skills will display here`} imageElement={<RatingAssessmentAccordionEmptyStateImage />} />
        )}
      </div>
    </Accordion>
  );
}
